import { render, staticRenderFns } from "./InvestorAccountTab.vue?vue&type=template&id=b172f282&scoped=true"
import script from "./InvestorAccountTab.vue?vue&type=script&lang=js"
export * from "./InvestorAccountTab.vue?vue&type=script&lang=js"
import style0 from "./InvestorAccountTab.vue?vue&type=style&index=0&id=b172f282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b172f282",
  null
  
)

export default component.exports